// extracted by mini-css-extract-plugin
module.exports = {"appbar":"Appbar_appbar__IWxgu","link":"Appbar_link__hojbE","link__active":"Appbar_link__active__3nq5f"};